import {
  IShowReturnsPanelAction,
  IHideReturnsPanelAction,
  ReturnsActionEnum,
  IFetchCapacityReturnsAction,
  IFetchCapacityReturnsSuccessAction,
  IFetchCapacityReturnsFailedAction,
  ISubmitCapacityReturnAction,
  ISubmitCapacityReturnSuccessAction,
  ISubmitCapacityReturnFailedAction
} from ".";

import {
  IAuction,
  ICapacityReturnRequest,
  ICapacityReturnResponse,
  ISourceAuction
} from "../../services";

export const ShowReturnsPanelAction = (auction: IAuction) => {
  return {
    type: ReturnsActionEnum.ShowReturnsPanel,
    auction,
  } as IShowReturnsPanelAction;
};

export const HideReturnsPanelAction = () => {
  return {
    type: ReturnsActionEnum.HideReturnsPanel,
  } as IHideReturnsPanelAction;
};

export const FetchCapacityReturnsAction = (auction: IAuction) => {
  return {
    type: ReturnsActionEnum.FetchCapacityReturns,
    auction,
  } as IFetchCapacityReturnsAction;
};

export const FetchCapacityReturnsSuccessAction = (sourceAuctions: ISourceAuction[], auction: IAuction) => {
  return {
    type: ReturnsActionEnum.FetchCapacityReturnsSuccess,
    sourceAuctions,
    auction,
  } as IFetchCapacityReturnsSuccessAction;
};

export const FetchCapacityReturnsFailedAction = (error: string) => {
  return {
    type: ReturnsActionEnum.FetchCapacityReturnsFailed,
    error,
  } as IFetchCapacityReturnsFailedAction;
};

export const SubmitCapacityReturnAction = (request: ICapacityReturnRequest) => {
  return {
    type: ReturnsActionEnum.SubmitCapacityReturn,
    request,
  } as ISubmitCapacityReturnAction;
};

export const SubmitCapacityReturnSuccessAction = (response: ICapacityReturnResponse) => {
  return {
    type: ReturnsActionEnum.SubmitCapacityReturnSuccess,
    response,
  } as ISubmitCapacityReturnSuccessAction;
};

export const SubmitCapacityReturnFailedAction = (error: string) => {
  return {
    type: ReturnsActionEnum.SubmitCapacityReturnFailed,
    error,
  } as ISubmitCapacityReturnFailedAction;
};